import { type OrganicStat } from "../../gql-generated/types";
import { type StatsItem } from "../models";

export const mapStatsArrayToIntValues = (list: readonly OrganicStat[]): StatsItem[] =>
    list.map(({ value, dimensionBreakdown }) => ({
        value: Number.parseInt(value),
        key: dimensionBreakdown,
    }));
